import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import { useState, useRef, useEffect } from "react";

export default function Section({
  id,
  title,
  highligtColor = "#7a3f00",
  children,
  videoSrc,
  containerStyles,
  headerStyles,
}) {
  return (
    <Box id={id} component="section" sx={{ position: "relative" }}>
      {videoSrc && (
        <Box
          component="video"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: { xs: "50vh", sm: "100vh" }, // <-- FIXED
            objectFit: "cover",
            zIndex: -2,
            filter: "brightness(0.55)",
          }}
        >
          <source src={videoSrc} type="video/webm" />
        </Box>
      )}
      <Container sx={{ position: "relative", zIndex: 0, ...containerStyles }}>
        {title && (
          <Typography
            variant="h5"
            component="h5"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              mt: 3,
              mb: 0,
              position: "relative",
              display: "inline-block",
              "&::after": {
                content: '""',
                display: "block",
                width: "60px",
                height: "4px",
                backgroundColor: highligtColor,
                borderRadius: "2px",
                margin: "12px auto 0",
              },
              ...headerStyles,
            }}
          >
            {title}
          </Typography>
        )}
        {children}
      </Container>
    </Box>
  );
}
